import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import BasicSelect from '../../../../../../shared/components/formComponents/groups/BasicSelect';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';

class CustomHomeOption extends Component {
    static propTypes = {
        fields: PropTypes.any,
        collectionOptions: PropTypes.array,
        allowMultipleCollections: PropTypes.bool,
        canEdit: PropTypes.bool,
        isGlobalContentRow: PropTypes.bool
    };

    moveUp = (i) => {
        if (i) {
            this.props.fields.swap(i, i - 1);
        }
    };

    moveDown = (i) => {
        if (i < this.props.fields.length - 1) {
            this.props.fields.swap(i, i + 1);
        }
    };

    render() {
        const { fields, collectionOptions, allowMultipleCollections = true, canEdit, isGlobalContentRow } = this.props;
        const fieldsArray = fields.map((collectionId, index) => (
            <div key={collectionId} className={'col-12 chooseSectionItem-optionInput'}>
                <div className={'row'}>
                    <div className={'col-8'}>
                        <Field
                            name={collectionId}
                            placeholder={'Select Path'}
                            className={'company-form-field no-horizontal-margin'}
                            options={collectionOptions}
                            disabled={!canEdit}
                            valueKey={'_id'}
                            labelKey={'name'}
                            component={BasicSelect}
                            inputClassName={'no-padding'}
                            styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                        />
                    </div>
                    {allowMultipleCollections && canEdit && (
                        <td className={'custom-home-button col-4'}>
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-angle-up'}
                                onClick={() => fields.swap(index, index - 1)}
                                title={'Move Up'}
                                disabled={!index}
                            />
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-angle-down'}
                                onClick={() => fields.swap(index, index + 1)}
                                title={'Move Down'}
                                disabled={index === fields.length - 1}
                            />
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-trash-alt'}
                                onClick={() => fields.remove(index)}
                                title={'Remove Collection'}
                            />
                        </td>
                    )}
                </div>
            </div>
        ));
        return (
            <div className={'chooseSectionItem-optionFields col-12'}>
                <div className={'row'}>{fieldsArray}</div>
                <br />
                {(allowMultipleCollections || fields.length < 1) && canEdit && (
                    <div className={'row'}>
                        <div className={`${isGlobalContentRow ? '' : 'col-4'} add-field-button`}>
                            <VerbButton
                                className={'full-width'}
                                fontAwesomeIcon={'fa-plus'}
                                onClick={() => fields.push('')}
                                buttonText={'Add Path'}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default CustomHomeOption;
